import { render, staticRenderFns } from "./PageGroup.vue?vue&type=template&id=37726c0d&"
import script from "./PageGroup.vue?vue&type=script&lang=js&"
export * from "./PageGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports